import { useTilesStore } from 'stores/RootStoreProvider'
import { type BaseTileStore } from 'stores/tilesStore/tiles/BaseTileStore'
import { AIGenPhotoTileStore } from 'stores/tilesStore/tiles/AIGenPhotoTileStore'
import { useMobxSelector } from 'utils/mobx/useMobxSelector'
import { AiTileGenerationTask } from './AiTileGenerationTask'

function isActiveAiGenTile(tile: BaseTileStore): tile is AIGenPhotoTileStore {
  return tile instanceof AIGenPhotoTileStore && tile.isGenerating
}

export function AiTileGenerationOrchestrator() {
  const tilesStore = useTilesStore()
  const activeTileIds = useMobxSelector(
    () => tilesStore.tiles.filter(isActiveAiGenTile).map((tile) => tile.id),
    [tilesStore]
  )

  return (
    <>
      {activeTileIds.map((tileId) => (
        <AiTileGenerationTask key={tileId} tileId={tileId} />
      ))}
    </>
  )
}
